export default "__VITE_ASSET__8e1ec6d8__"